import { Component, Input, OnInit, ChangeDetectionStrategy, SimpleChanges } from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";
import { Breadcrumb } from "./breadcrumb.interfaces";
import { environment } from "src/environments/environment";
import { SeoService } from "../../services/seo.service";
import { SharedService } from "../../services/shared.service";

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BreadcrumbComponent implements OnInit {

    constructor(
        private seoService: SeoService,
        private sharedService: SharedService,
        private cdr: ChangeDetectorRef
    ) {
    }
    @Input() data: Breadcrumb[] = []

    breadcrumbs: Breadcrumb[] = [
        {
            name: 'Home',
            link: '/categories',
            active: true
        }
    ]
    baseUrl: string = environment.baseUrl

    ngOnInit(): void {
        this.initData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            this.initData();
            //this.cdr.detectChanges();
        }
    }

    initData() {
        this.breadcrumbs = [
            {
                name: 'Home',
                link: '/',
                active: true
            }
        ]
        if (this.data.length > 0) this.breadcrumbs[0].active = false;
        this.breadcrumbs = [...this.breadcrumbs, ...this.data.filter(breadcrumb => breadcrumb?.link)];
        this.breadcrumbs = this.breadcrumbs.filter(breadcrumb => breadcrumb?.link)

        const lastBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 1]
        this.breadcrumbs[this.breadcrumbs.length - 1].name = lastBreadcrumb.name.length > 16 ? lastBreadcrumb.name.substr(0, 16) + '...' : lastBreadcrumb.name;
        const schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": this.breadcrumbs.map((row, index) => {
                return {
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": row.name,
                    "item": "https://kachiing.com" + row.link
                }
            })
        }

        if (this.sharedService.isBrowser()) {
            // console.log(schema, "THIS IS BREADCRUMB SCHEMA")
            this.seoService.updateSchema('custom', JSON.stringify(schema))
        }
    }
}